import React, { createContext, useState, useEffect, useCallback } from "react";
import { trackPromise } from "react-promise-tracker";
import guService from "../services/guService";
import Swal from "sweetalert2";

export const ClienteContext = createContext({});

export function ClienteProvider({ children }) {
    const [clientesLista, setClientesLista] = useState([]);
    const [clienteSelecionado, setClienteSelecionado] = useState();

    useEffect(() => {
        let usuarioLogado = guService.getLocalState("idUsuario");
        if (usuarioLogado && usuarioLogado !== "null" && usuarioLogado !== "") {
            recarregarClientes();
        }
    }, []);

    useEffect(() => {
        resolverClienteSelecionado();
    }, [clientesLista]);

    const recarregarClientes = () => {
        trackPromise(
            guService.cliente
                .buscar(guService.getLocalState("idUsuario"))
                .then((res) => {
                    setClientesLista(res.data);
                })
                .catch((err) => {
                    Swal.fire({
                        titleText: "Erro",
                        text:
                            "Houve um problema ao buscar a lista de clientes " +
                            err,
                        icon: "error",
                    });
                    return;
                })
        );
    };

    const resolverClienteSelecionado = useCallback(() => {
        let clienteStorage = guService.getLocalState("idCliente");
        if (clienteStorage) {
            let temp = clientesLista.find((cliente) => {
                return cliente.id === parseInt(clienteStorage);
            });
            if (temp) {
                setClienteSelecionado(temp);
            }
        }
    }, [clientesLista]);

    return (
        <ClienteContext.Provider
            value={{
                clientesLista,
                clienteSelecionado,
                setClienteSelecionado,
                recarregarClientes,
            }}
        >
            {children}
        </ClienteContext.Provider>
    );
}
